module.exports = __webpack_public_path__ + "img/logo.40a91d9e.png";